import register from '@/components/features/cms/blocks/Carousel/register';
import { CarouselWithOverrides } from './CarouselWithOverrides';

register(CarouselWithOverrides);
